<template>
  <div>
    <el-form :model="articleData" :rules="rules" ref="articleData" label-width="100px">
      <el-form-item label="文章标题" prop="title">
        <el-input v-model="articleData.title" placeholder="请输入文章标题"></el-input>
      </el-form-item>
      <el-form-item label="文章内容" prop="content">
        <el-input v-model="articleData.content" placeholder="请输入文章内容"></el-input>
      </el-form-item>
      <el-form-item label="文章分类" prop="category">
        <el-select class="select_container" v-model="articleData.category" placeholder="请选择文章分类">
          <el-option v-for="(item,key) in categories" :key="key" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文章链接" prop="url">
        <el-input v-model="articleData.url" placeholder="https://"></el-input>
      </el-form-item>
      <el-form-item label="文章标签">
        <el-tag
          v-for="item in articleData.tags"
          :key="item"
          closable
          :disable-transitions="false"
          @close="deleteItem(item)">
          {{item}}
        </el-tag>
        <el-input
          class="temp-input"
          v-if="tempInputStatus"
          v-model="tempInputValue"
          ref="tempInput"
          size="small"
          @keyup.enter.native="createItem"
          @blur="createItem"
        >
        </el-input>
        <el-button v-else class="show-input-button" size="small" @click="showTempInput">添加标签</el-button>
      </el-form-item>
      <el-form-item label="文章图片">
        <el-upload
          class="upload-image"
          name="attachment"
          action=""
          accept="image/*"
          :http-request="(params)=>changeImage(params)"
          :multiple="false"
          :show-file-list="false"
          :before-upload="beforeUpload">
          <img v-if="articleData.image" class="preview-image" :src="articleData.image">
          <i v-else class="el-icon-plus upload-image-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="发布时间">
        <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="articleData.publishedTime"></el-date-picker>
      </el-form-item>
      <el-form-item label="是否登录">
        <el-switch v-model="articleData.isAuthorization"></el-switch>
      </el-form-item>
      <el-form-item label="是否展示">
        <el-switch v-model="articleData.isOpen"></el-switch>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="validate">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'EditArticle',
  props: {
    articleData: Object,
    submitData: Function
  },
  data () {
    return {
      categories: [],
      rules: {
        title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入文章内容', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请输入文章分类', trigger: 'blur' }
        ],
        // image: [
        //   { required: true, message: '请输入文章图片', trigger: 'blur' }
        // ],
        url: [
          { required: true, message: '请输入文章链接', trigger: 'blur' }
        ]
      },
      tempInputStatus: false,
      tempInputValue: '',
      image: null
    }
  },
  async created () {
    const { categories } = await this.$http.get('/categories/')
    this.categories = categories
  },
  methods: {
    deleteItem (item) {
      let tempItems = this.articleData.tags
      tempItems = tempItems.filter(x => x !== item)
      this.articleData.tags = tempItems
    },
    showTempInput () {
      this.tempInputStatus = true
      this.$nextTick(_ => {
        this.$refs.tempInput.$refs.input.focus()
      })
    },
    createItem () {
      let inputValue = this.tempInputValue
      if (inputValue && inputValue.trim()) {
        if (!this.articleData.tags) {
          this.articleData.tags = []
        }
        if (this.articleData.tags.includes(inputValue.trim())) {
          this.$message({
            message: '分类已存在',
            type: 'error'
          })
          return
        }
        this.articleData.tags.push(inputValue.trim())
      }
      this.tempInputStatus = false
      this.tempInputValue = ''
    },
    beforeUpload (file) {
      const isImage = file.type.includes('image')
      if (!isImage) {
        this.$message.error('上传图片只能是图片格式!')
      }
      // const isLimit = file.size / 1024 / 1024 < 2
      // if (!isLimit) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!')
      // }
      return isImage
    },
    async changeImage (params) {
      this.image = URL.createObjectURL(params.file)
      let formData = new FormData()
      formData.append('attachment', params.file)
      let data = await this.$http.post('/images/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      this.articleData.image = data.file.link
    },
    validate () {
      this.$refs.articleData.validate(async (status, rule) => {
        if (status) {
          this.articleData.type = 'article'
          const resp = await this.submitData()
          if (resp.article) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: resp.error,
              type: 'warning'
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.select_container {
  display: block;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.show-input-button {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.temp-input {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.upload-image-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.preview-image {
  height: 178px;
  display: block;
}
</style>
